import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Get } from "../axios/AxiosFunctions.js";
import { BaseURL } from "../config/apiUrl.js";
import { updateUser } from "../store/auth/authSlice.js";
import {
  setStates,
  setUnReadNotificationCount,
} from "store/common/commonSlice.js";

export const useGetMe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { isLogin, access_token } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();

  const getMe = async () => {
    const apiUrl = BaseURL("users/get-me");
    const notificationUrl = BaseURL("notifications/unreadCount");
    const statesUrl = BaseURL("states/admin/all");
    setIsLoading(true);
    const [userRes, notificationRes, statesRes] = await Promise.allSettled([
      isLogin ? Get(apiUrl, access_token, false, dispatch) : null,
      isLogin ? Get(notificationUrl, access_token, false, dispatch) : null,
      isLogin ? Get(statesUrl, access_token, false, dispatch) : null,
    ]);
    if (userRes?.value) {
      dispatch(updateUser(userRes?.value?.data?.data?.user));
    }
    if (notificationRes?.value) {
      dispatch(
        setUnReadNotificationCount(
          notificationRes?.value?.data?.data?.unreadCount
        )
      );
    }
    if (statesRes?.value) {
      const resData = statesRes?.value?.data?.data?.states;
      dispatch(setStates(resData));
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getMe();
  }, []);
  return isLoading;
};
